import BaseComponent from "../../../baseComponent.js";
import Expression from "./expression.jsx";
import MinMax from "./minMax.jsx";
import Color  from "./color.jsx";
import styles from "./styles.scss";


export default class GaugeConfig extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={styles.legendConfig} name="legendConfig" ref="container">
        <div className={styles.legendConfigContent}>
          <Expression label="Data"
                      widgetId={this.props.widgetId}
                      legendId={this.props.legend.id}
                      expressionKey="y"
                      onLegendChange={this.props.onLegendChange}
                      expression={this.props.legend.expressions.y}
                      mappings={this.props.legend.mappings} callback={this.props.callback}/>
          <MinMax max={this.props.legend.parameters.chartTypeParameters.max}
                  onLegendChange={this.props.onLegendChange}/>
          <Color field="minColor" label="Min Color" color={this.props.legend.parameters.minColor}
                 onLegendChange={this.props.onLegendChange}/>
          <Color field="maxColor" label="Max Color" color={this.props.legend.parameters.maxColor}
                 onLegendChange={this.props.onLegendChange}/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/gagueConfig.jsx